<template>
  <div class="report-meta-bar">
    <div class="meta-grid">
      <div class="meta-item">
        <span class="meta-label">数据源</span>
        <el-tag size="mini" :type="sourceTagType">{{
          meta.source || "--"
        }}</el-tag>
      </div>
      <div class="meta-item">
        <span class="meta-label">陈旧数据</span>
        <el-tag size="mini" :type="meta.stale ? 'danger' : 'success'">
          {{ meta.stale ? "是" : "否" }}
        </el-tag>
      </div>
      <!-- <div class="meta-item">
        <span class="meta-label">币种</span>
        <span class="meta-value">{{ meta.currency || "--" }}</span>
      </div>
      <div class="meta-item">
        <span class="meta-label">时区</span>
        <span class="meta-value">{{ meta.time_zone || "--" }}</span>
      </div> -->
    </div>

    <!-- <div class="signature-row">
      <span class="meta-label">请求签名</span>
      <span class="signature-text">{{ meta.request_signature || "--" }}</span>
    </div> -->

    <!-- <div class="rule-row" v-if="formattedRules.length">
      <span class="meta-label">命中规则</span>
      <div class="rule-list">
        <el-tag
          v-for="item in formattedRules"
          :key="item"
          size="mini"
          effect="plain"
          type="warning"
        >
          {{ item }}
        </el-tag>
      </div>
    </div> -->

    <el-alert
      v-if="meta.stale"
      title="当前展示的是 MySQL 回退数据，上游查询失败，请留意时效性。"
      type="warning"
      :closable="false"
      show-icon
      class="stale-alert"
    />
  </div>
</template>

<script>
export default {
  name: "ReportMetaBar",
  props: {
    meta: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    sourceTagType() {
      const source = String(this.meta.source || "").toLowerCase();
      if (source === "upstream") {
        return "success";
      }
      if (source === "mysql") {
        return "warning";
      }
      if (source === "redis") {
        return "info";
      }
      return "";
    },
    formattedRules() {
      return (this.meta.applied_rules || [])
        .map((item) => {
          if (!item || !item.code) {
            return "";
          }
          if (item.detail && typeof item.detail === "object") {
            return `${item.code}: ${JSON.stringify(item.detail)}`;
          }
          return item.code;
        })
        .filter(Boolean);
    },
  },
};
</script>

<style lang="less" scoped>
.report-meta-bar {
  padding: 16px 18px;
  border-radius: 16px;
  background: linear-gradient(180deg, #f9fbff 0%, #f4f8ff 100%);
  border: 1px solid #e1ebfb;
}

.meta-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 12px;
}

.meta-item,
.signature-row,
.rule-row {
  display: flex;
  align-items: center;
  gap: 10px;
}

.signature-row,
.rule-row {
  margin-top: 14px;
}

.meta-label {
  flex-shrink: 0;
  color: #6d83a8;
  font-size: 12px;
}

.meta-value,
.signature-text {
  color: #203864;
  font-size: 13px;
  word-break: break-all;
}

.rule-list {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.stale-alert {
  margin-top: 14px;
}

@media (max-width: 1200px) {
  .meta-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 768px) {
  .meta-grid {
    grid-template-columns: 1fr;
  }

  .signature-row,
  .rule-row {
    align-items: flex-start;
    flex-direction: column;
  }
}
</style>
